// Inspired from https://github.com/stimulus-components/stimulus-checkbox-select-all/
// to allow grouped checkboxes: show the select all button in tabbar, and select a certain checkbox_group

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkboxAll', 'checkboxGroup', 'checkbox'];

  connect() {
    this.refresh();
  }

  refresh() {
    for (const cgt of this.checkboxGroupTargets) {
      const group = cgt.dataset.checkboxGroup;
      const checkedCount = this.checked(group).length;
      const uncheckedCount = this.unchecked(group).length;
      cgt.checked = checkedCount > 0;
      cgt.indeterminate = checkedCount > 0 && uncheckedCount > 0;
    }

    const allCheckedCount = this.allChecked().length;
    const allUncheckedCount = this.allUnchecked().length;

    if (this.hasCheckboxAllTarget) {
      this.checkboxAllTarget.checked = allCheckedCount > 0;
      this.checkboxAllTarget.indeterminate = allCheckedCount > 0 && allUncheckedCount > 0;
    }
  }

  toggleAll(e) {
    e.preventDefault();
    let changedCheckboxes = [];

    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.disabled && checkbox.checked !== e.target.checked) {
        checkbox.checked = e.target.checked;
        checkbox.indeterminate = false;
        changedCheckboxes.push(checkbox);
      }
    });
    this.checkboxGroupTargets.forEach((checkbox) => {
      if (!checkbox.disabled && checkbox.checked !== e.target.checked) {
        checkbox.checked = e.target.checked;
        checkbox.indeterminate = false;
        changedCheckboxes.push(checkbox);
      }
    });
    changedCheckboxes.forEach((checkbox) => {
      checkbox.dispatchEvent(new Event('change'));
    });
  }

  toggleGroup(e) {
    let group = e.target.dataset.checkboxGroup;
    let changedCheckboxes = [];
    this.checkboxTargetsForGroup(group).forEach((checkbox) => {
      if (!checkbox.disabled && checkbox.checked !== e.target.checked) {
        checkbox.checked = e.target.checked;
        changedCheckboxes.push(checkbox);
      }
    });
    changedCheckboxes.forEach((checkbox) => {
      checkbox.dispatchEvent(new Event('change'));
    });
    this.refresh();
  }

  checkboxTargetsForGroup(group) {
    return this.checkboxTargets.filter((cbt) => cbt.dataset.checkboxGroup === group);
  }

  checked(group) {
    return this.checkboxTargetsForGroup(group).filter((cbt) => cbt.checked);
  }

  unchecked(group) {
    return this.checkboxTargetsForGroup(group).filter((cbt) => !cbt.checked);
  }

  allChecked() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked);
  }

  allUnchecked() {
    return this.checkboxTargets.filter((checkbox) => !checkbox.checked);
  }
}
